module.exports = __webpack_public_path__ + "img/regiter-icon06.fefe49c9.png";